import { usePermission } from '@/common/hooks/index';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './index.less';

const InterHospiSuperPlatform: React.FC = () => {
  const navigate = useNavigate();
  const { permission } = usePermission();

  const itemLis = [
    {
      id: 1,
      label: '国家药品供应保障综合管理信息平台药品目录',
      url: '/datamanagement/datalake/platform/drugCatalog',
      root: 'intDrugCataTable',
    },
    {
      id: 2,
      label: '医疗服务收费项目医保目录',
      url: '/datamanagement/datalake/platform/catalogueMedicalItem',
      root: 'intCataMedTable',
    },
    {
      id: 3,
      label: '疾病分类与代码（2019）',
      url: '/datamanagement/datalake/platform/diseaseClassifyCode',
      root: 'intDisCodeTable',
    },
    {
      id: 4,
      label: '2018年行政区化码',
      url: '/datamanagement/datalake/platform/administrativeCode',
      root: 'intAdmCodeTable',
    },
  ];

  return (
    <div className={styles.inter}>
      <div className={styles.title}>广东省</div>
      <div className={styles.container}>
        {itemLis.map((el) =>
          permission[el.root] ? (
            <div key={el.id} className={styles.item} onClick={() => navigate(el.url)}>
              <div className={styles.header}>
                <span className={styles.idx}>{el.id}</span>
                <span className={styles.name}>{el.label}</span>
              </div>
              <div className={styles.database}>查看数据库</div>
            </div>
          ) : null,
        )}
      </div>
    </div>
  );
};

export default InterHospiSuperPlatform;
